import { carouselData } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20geometric%20composition%20with%20flowing%20organic%20shapes%2C%20modern%20digital%20art%20style%2C%20soft%20gradients%20from%20amber%20to%20cream%2C%20minimalist%20clean%20aesthetic%2C%20luxurious%20smooth%20textures%2C%20cinematic%20atmospheric%20lighting&width=1600&height=686&seq=carousel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20abstract%20wave%20patterns%20in%20warm%20coral%20and%20cream%20tones%2C%20smooth%20flowing%20curves%2C%20modern%20minimalist%20design%2C%20soft%20ethereal%20lighting%2C%20premium%20textured%20finish%2C%20harmonious%20warm%20color%20palette&width=800&height=450&seq=carousel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20layered%20circles%20with%20golden%20honey%20and%20warm%20beige%20hues%2C%20modern%20art%20deco%20inspired%2C%20smooth%20gradients%2C%20luxurious%20feel%2C%20soft%20diffused%20lighting%2C%20premium%20aesthetic%20composition&width=800&height=450&seq=carousel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20abstract%20fluid%20art%20with%20amber%20terracotta%20and%20cream%20swirls%2C%20organic%20flowing%20shapes%2C%20modern%20gallery%20style%2C%20soft%20atmospheric%20glow%2C%20minimalist%20luxurious%20composition%2C%20rich%20textural%20details&width=800&height=450&seq=carousel-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Contemporary%20abstract%20mosaic%20with%20warm%20golden%20and%20terracotta%20tiles%2C%20geometric%20patterns%20intersecting%2C%20modern%20luxury%20design%2C%20soft%20ambient%20warm%20lighting%2C%20premium%20textured%20surface%2C%20harmonious%20elegant%20composition&width=800&height=450&seq=carousel-05&orientation=landscape',
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {carouselData.title}
        </h2>

        <div className="flex flex-col gap-4 md:gap-5">
          <div className="group relative rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative aspect-[21/9] w-full">
              <img
                src={carouselImages[0]}
                alt={carouselData.items[0].title}
                title={carouselData.items[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
              <h3 className="font-heading text-lg md:text-xl text-background-50 mb-1">
                {carouselData.items[0].title}
              </h3>
              <p className="text-sm text-background-200 leading-relaxed line-clamp-2">
                {carouselData.items[0].desc}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {carouselData.items.slice(1).map((item, i) => (
              <div
                key={i}
                className="group relative rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[4/3] w-full">
                  <img
                    src={carouselImages[i + 1]}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <h3 className="font-heading text-sm md:text-base text-background-50 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-background-200 leading-relaxed line-clamp-2 hidden sm:block">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}